export default __webpack_public_path__ + "static/media/get-money.bda3d0fe.png";